import { Box } from '@mui/material'
import { FC, useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGuestStore } from '../../../feat/guest/guest.store'
import { useScrollContext } from '../../../state/scrollState/scrollContext'
import { windowSizes } from '../../../state/windowState/windowSignals'
import LiveLocationShareControl from '../map/controls/liveLocationShareControl'
import { CarouselSeeAllItineraries } from './slide/newComps/seeAllItineraries'
import CarouselZoneToggle from './slide/newComps/zoneToggle'

export const CarouselOverlay: FC = () => {
    const { headerHeight } = useScrollContext(
        useShallow((s) => ({ headerHeight: s.headerHeight }))
    )

    const Wrapper = useCallback(
        (
            children: React.ReactNode,
            top = (windowSizes.value.insets?.insets.top ?? 0) + 8,
            right?: number
        ) => {
            return (
                <Box
                    position={'absolute'}
                    zIndex={1000}
                    top={top}
                    right={right}
                    sx={{
                        opacity: headerHeight === 156 ? '1' : '0',
                        transition: 'opacity 0.2s',
                        pointerEvents: headerHeight === 156 ? 'auto' : 'none',
                    }}
                >
                    {children}
                </Box>
            )
        },
        [headerHeight, windowSizes]
    )

    return (
        <>
            {!useGuestStore.getState().isGuestMode &&
                Wrapper(
                    <Box
                        className="CarouselSeeAllItineraries"
                        sx={{
                            display: 'grid',
                            paddingLeft: '16px',
                        }}
                    >
                        <CarouselSeeAllItineraries />
                    </Box>
                )}

            {Wrapper(
                <Box
                    className="CarouselZoneToggle"
                    sx={{
                        display: 'grid',
                        paddingRight: '16px',
                    }}
                >
                    <CarouselZoneToggle />
                </Box>,
                undefined,
                0
            )}

            {Wrapper(
                <Box
                    className="CarouselLiveLocationToggle"
                    sx={{
                        display: 'grid',
                        paddingRight: '16px',
                    }}
                >
                    <LiveLocationShareControl />
                </Box>,
                (windowSizes.value.insets?.insets.top ?? 0) + 86,
                0
            )}
        </>
    )
}
